import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Header from "./content/header"
import {Helmet} from 'react-helmet'


class IndexUser extends Component {


  componentDidMount(){
    document.getElementById("iniciomenu").classList.toggle("bg-light");

  }
   
    togglemenu = ()=> {
        document.getElementById("sidebar").classList.toggle("active");
        document.getElementById("content").classList.toggle("active");
    }

  render() {
  

    return (
        
      <React.Fragment>
        <Header />
        <Helmet>
            <title>Painel | Faculdade Olga Mettig</title>
        </Helmet>

<div class="page-content white" id="content">
  

  <button id="sidebarCollapse" onClick={this.togglemenu} type="button" class="btn btn-light bg-white rounded-pill shadow-sm px-4 mb-4"><i class="fa fa-bars mr-2"></i><small class="text-uppercase font-weight-bold">Toggle</small></button>
  
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/user">Pagina Inicial</a></li>
        </ol>
    </nav>
 
  <div class="separator"></div>
  <div class="row text-black contentp">
    <div class="col-lg-7">
    











    
    </div>
    
  </div>

</div>


      </React.Fragment>
       
    );
  }
}

export default withRouter(IndexUser);


// WEBPACK FOOTER //
// ./src/pages/User/index.js